import { Supply_chain } from "../../../db_access/supply_chain";
import OrganizationalComparison from "../../../organizational-pages/OrganizationalComparison";

const SupplyChainComparison = () => {
  return <OrganizationalComparison Org={Supply_chain} />;
};

export default SupplyChainComparison;
